import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ProjectAPI } from 'api/project';
import { GENERAL_API_STALE } from 'config/query-config';
export const getProjectBaselineQueryKey = (projectId)=>[
        'project-baselines',
        projectId
    ];
export const useCreateProjectBaselineMutation = (projectId)=>{
    const queryClient = useQueryClient();
    const queryKey = getProjectBaselineQueryKey(projectId);
    return useMutation((payload)=>ProjectAPI.createProjectBaseline(projectId, payload), {
        onMutate: async ()=>{
            await queryClient.cancelQueries(queryKey);
            const previous = queryClient.getQueryData(queryKey) || [];
            return {
                previous
            };
        },
        onSuccess: async (data, _, context)=>{
            var _ref;
            const prev = (_ref = context === null || context === void 0 ? void 0 : context.previous) !== null && _ref !== void 0 ? _ref : [];
            queryClient.setQueryData(queryKey, [
                ...prev,
                data
            ]);
        }
    });
};
export const useUpdateProjectBaselineMutation = (projectId)=>{
    const queryClient = useQueryClient();
    const queryKey = getProjectBaselineQueryKey(projectId);
    return useMutation(({ baselineId, ...payload })=>ProjectAPI.updateProjectBaseline(projectId, Number(baselineId), payload), {
        onMutate: async ()=>{
            await queryClient.cancelQueries(queryKey);
            const previous = queryClient.getQueryData(queryKey) || [];
            return {
                previous
            };
        },
        onSuccess: async (data, request, context)=>{
            var _ref;
            const prev = (_ref = context === null || context === void 0 ? void 0 : context.previous) !== null && _ref !== void 0 ? _ref : [];
            const result = prev.map((_baseline)=>_baseline.baselineId !== request.baselineId ? _baseline : data);
            queryClient.setQueryData(queryKey, [
                ...result
            ]);
        }
    });
};
export const useDeleteProjectBaselineMutation = (projectId)=>{
    const queryClient = useQueryClient();
    const queryKey = getProjectBaselineQueryKey(projectId);
    return useMutation((baselineId)=>ProjectAPI.deleteProjectBaseline(projectId, baselineId), {
        onMutate: async ()=>{
            await queryClient.cancelQueries(queryKey);
            const previous = queryClient.getQueryData(queryKey) || [];
            return {
                previous
            };
        },
        onSuccess: async (data, baselineId, context)=>{
            var _ref;
            const prev = (_ref = context === null || context === void 0 ? void 0 : context.previous) !== null && _ref !== void 0 ? _ref : [];
            const result = prev.map((_baseline)=>_baseline.baselineId !== baselineId ? _baseline : {
                    ..._baseline,
                    deleted: true
                });
            queryClient.setQueryData(queryKey, [
                ...result
            ]);
        }
    });
};
export const useProjectBaselineQuery = (projectId)=>{
    return useQuery(getProjectBaselineQueryKey(projectId), async ()=>{
        const baselines = await ProjectAPI.getProjectBaselines(projectId);
        return baselines.sort((a, b)=>a.createdAt - b.createdAt);
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        staleTime: GENERAL_API_STALE
    });
};
